export default {
    namespaced: true,
    modules: {
        google: require("./google").default,
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/mario/index.js